/** First element in the tab order; jumps past the shell to the page content. */
export function SkipLink() {
  return (
    <a
      href="#main-content"
      className="skip-link rounded-lg bg-accent px-4 py-2 text-[13px] font-medium text-accent-fg shadow-lg"
    >
      Skip to main content
    </a>
  );
}
